import stanceDrawn from "../../ui/art/hud-slots/stance-drawn_16.png";
import stanceSheathed from "../../ui/art/hud-slots/stance-sheathed_16.png";
import swap from "../../ui/art/hud-slots/swap_16.png";

/**
 * The icons the 22 logical pixel ability slots show (the stance button and the swap control, on every page): original 16 by 16
 * art hand drawn for the slot, under `ui/art/hud-slots/`, drawn one icon pixel to one logical pixel, so it stays crisp at every
 * UI scale and sits inside a slot's well (`slot-art.ts`). The swap icon keeps its bottom right corner clear of the page's
 * "1/2" digits.
 */
export const SLOT_ICONS = { stanceDrawn, stanceSheathed, swap } as const;

/**
 * The slot icons' size in logical pixels.
 */
export const SLOT_ICON_SIZE = 16;
